/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnterTenantPayload
 */
export interface EnterTenantPayload {
    /**
     * 
     * @type {string}
     * @memberof EnterTenantPayload
     */
    token?: string;
}

/**
 * Check if a given object implements the EnterTenantPayload interface.
 */
export function instanceOfEnterTenantPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnterTenantPayloadFromJSON(json: any): EnterTenantPayload {
    return EnterTenantPayloadFromJSONTyped(json, false);
}

export function EnterTenantPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnterTenantPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function EnterTenantPayloadToJSON(value?: EnterTenantPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

